module.exports = __webpack_public_path__ + "static/img/1-1Z524145RY56.e65aa65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z524145RY56.jpg
// module id = GZuh
// module chunks = 0